import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import classNames from './Icon.module.scss';

export const IconAdjustments = ({ style, grow }: SVGIconProps) => {
  return (
    <Center style={style} classNames={classNames} data-grow={grow}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_276_10753)">
          <path
            d="M2.50004 2.98807C2.50004 2.54605 2.67564 2.12212 2.9882 1.80956C3.30076 1.497 3.72468 1.32141 4.16671 1.32141C4.60874 1.32141 5.03266 1.497 5.34522 1.80956C5.65778 2.12212 5.83337 2.54605 5.83337 2.98807M2.50004 2.98807C2.50004 3.4301 2.67564 3.85402 2.9882 4.16659C3.30076 4.47915 3.72468 4.65474 4.16671 4.65474C4.60873 4.65474 5.03266 4.47915 5.34522 4.16659C5.65778 3.85402 5.83337 3.4301 5.83337 2.98807M2.50004 2.98807L4.09351e-05 2.98807M5.83337 2.98807L13.3334 2.98807M7.91671 10.4167C7.91671 9.97462 8.0923 9.5507 8.40486 9.23814C8.71742 8.92558 9.14135 8.74998 9.58337 8.74998C10.0254 8.74998 10.4493 8.92558 10.7619 9.23814C11.0744 9.5507 11.25 9.97462 11.25 10.4167M7.91671 10.4167C7.91671 10.8587 8.0923 11.2826 8.40486 11.5952C8.71742 11.9077 9.14135 12.0833 9.58337 12.0833C10.0254 12.0833 10.4493 11.9077 10.7619 11.5952C11.0744 11.2826 11.25 10.8587 11.25 10.4167M7.91671 10.4167L4.06104e-05 10.4167M11.25 10.4167L13.3334 10.4167"
            stroke="#676979"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_276_10753">
            <rect
              width="13.3333"
              height="13.3333"
              fill="white"
              transform="translate(13.3334) rotate(90)"
            />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
